import {getCategoryUrl} from '@/_application/modules/categories/models/url';
import {CategoryTree} from '__generated__/__types__';
import Link from 'next/link';
import React from 'react';

const ProductCategorySpotlightHeader = ({name, categories}: {name?: string; categories: CategoryTree[]}) => {
    // return if no categories
    if (!categories || categories.length <= 0) {
        return null;
    }

    return (
        <div className="mb-5 flex items-center justify-between">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <Link
                    href={getCategoryUrl(categories[0]) ?? '/'}
                    className="text-[22px] font-extrabold leading-[25px] text-KPZ_Blue-Dark transition-opacity hover:opacity-80">
                    <h2>{name}</h2>
                </Link>

                <div className="mt-0.5 flex items-center text-sm leading-4 lg:text-base">
                    {categories?.slice(1).map(item => (
                        <Link
                            href={getCategoryUrl(item) ?? '/'}
                            passHref
                            key={item?.canonical_url}
                            className="cursor-pointer border-r border-black px-4 transition-colors first:pl-0 last:border-r-0 hover:text-KPZ_Orange-30">
                            {item?.name}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default ProductCategorySpotlightHeader;
